(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider
                .state("Home.Tools.MarketingTracker.Summary",
                    {
                        url: "/Summary",
                        component: "summary",
                        PageTitle: "Marketing Tracker Summary",
                        resolve: {
                            onBehalfOfUser: ["userApi", "permissionService", function (userApi, permissionService) {
                                var onBehalfOfUserId = permissionService.getOnBehalfOfUserId();
                                if (onBehalfOfUserId)
                                    return userApi.get(onBehalfOfUserId).catch(ng.noop);
                                return null;
                            }],
                            eventTypes: function () {
                                return {
                                    //Cumulative: ["Dinner Seminars", "Client Appreciation Events", "Client Educational Events", "Social Events",
                                    //    "Holiday Events", "College Courses", "College Courses - Power of Zero", "Referral Events", "Social Security Seminars"],
                                    ClientEvents: {
                                        name: "Client Events",
                                        types: ["All", "Client Appreciation Events", "Client Educational Events", "Social Events", "Holiday Events", "Referral Events"]
                                    },
                                    CollegeCourses: {
                                        name: "College Classes",
                                        types: ["All", "College Courses", "College Courses - Power of Zero"]
                                    },
                                    DinnerSeminars: {
                                        name: "Dinner Seminars",
                                        types: ["All", "Dinner Seminars"]
                                    },
                                    SSSeminars: {
                                        name: "Social Security Seminars",
                                        types: ["All", "Social Security Seminars"]
                                    },
                                    Referrals: {
                                        name: "Referrals",
                                        types: ["All", "Referral Events", "Client Appreciation Events", "Client Educational Events",
                                            "Social Events", "Holiday Events", "Dinner Seminars", "College Courses", "College Courses - Power of Zero", "Social Security Seminars"]
                                    }
                                };
                            }
                        },
                        redirectTo: "Home.Tools.MarketingTracker.Summary.Cumulative"
                    });
        }
    ]);

    app
        .component("summary",
            {
                templateUrl: "App/Tools/MarketingTracker/Summary/summary-template.html",
                controller: summaryController,
                bindings: {
                    user: "<",
                    onBehalfOfUser: "<",
                    eventTypes: "<"
                }
            });

    summaryController.$inject = ["eventGroupApi", "_", "moment"];
    function summaryController(eventGroupApi, _, moment) {
        var $ctrl = this;
        ng.extend($ctrl,
            {
                ui: {
                    summaryView: 0
                },
                year: (new Date).getUTCFullYear(),
                years: [],
                getUserEvents: getUserEvents,
                getDoughnuts: getDoughnuts,
                resetYear: resetYear
            });

        function resetYear() {
            $ctrl.year = (new Date()).getUTCFullYear();
        }

        function getUserEvents(figAuthUserId, eventTypes, nextPageToken) {
            var startDate, endDate;
            if ($ctrl.twelveMonths) {
                startDate = moment(new Date()).add(-1, "year").toISOString();
                endDate = moment(new Date()).toISOString();
            } else {
                startDate = moment(new Date($ctrl.year, 0, 1)).toISOString();
                endDate = moment(new Date($ctrl.year + 1, 0, 1)).toISOString();
            }
            return getUserEventsByDate(figAuthUserId, eventTypes, startDate, endDate, nextPageToken);
        }

        function getUserEventsByDate(figAuthUserId, eventTypes, startDate, endDate, nextPageToken) {
            return eventGroupApi
                .getUserEventGroupsByDate(eventTypes, startDate, endDate, nextPageToken).then(
                    function (events) {
                        if (!events.NextPage) return events;
                        return getUserEventsByDate(figAuthUserId, eventTypes, startDate, endDate, events.NextPage).then(
                            function (recursiveEvents) {
                                return events = _.concat(events, recursiveEvents);
                            });
                    });
        }

        function getDoughnuts(num) {
            if (num < 0) return [0, 100];
            return [num, num < 100 ? 100 - num : 0];
        }

        for (var i = $ctrl.year - 2; i <= $ctrl.year + 2; i++) {
            $ctrl.years.push(i);
        }

        //if ($state.current.name === "Home.Tools.MarketingTracker.Summary")
        //    $state.go("Home.Tools.MarketingTracker.Summary.Cumulative");
    }

})(window.app, window.angular); //jshint ignore:line